import { useGetAnalyticsPropertyDataByQueryQuery } from "../../../../../../../../../shell/services/analytics";
import { findTopDimensions, generateDateRangesForReport } from "../../../utils";
import { ItemsTableContent } from "./ItemsTable";
type Props = {
  propertyId: string;
  startDate: Date;
  endDate: Date;
};
export const MostPopularWrapper = ({
  propertyId,
  startDate,
  endDate
}: Props) => {
  const {
    data: pathsData,
    isFetching
  } = useGetAnalyticsPropertyDataByQueryQuery({
    property: propertyId,
    requests: [{
      dimensions: [{
        name: "pagePath"
      }],
      metrics: [{
        name: "screenPageViews"
      }],
      dateRanges: generateDateRangesForReport(startDate, endDate),
      limit: "10",
      orderBys: [{
        metric: {
          metricName: "screenPageViews"
        },
        desc: true
      }]
    }]
  }, {
    skip: !propertyId
  });
  const paths = findTopDimensions(pathsData?.reports?.[0]?.rows, ["date_range_0"], 10)?.map(row => row[0].value) || [];
  return <ItemsTableContent propertyId={propertyId} startDate={startDate} endDate={endDate} paths={paths} showSkeleton={isFetching} data-sentry-element="ItemsTableContent" data-sentry-component="MostPopularWrapper" data-sentry-source-file="MostPopularWrapper.tsx" />;
};